// =============================================================================
// PublicNavbar - Navigation bar for unauthenticated pages (from Figma design)
// =============================================================================

import { useNavigate } from 'react-router-dom';

export function PublicNavbar() {
  const navigate = useNavigate();

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 cursor-pointer"
          >
            <img
              src="/logo-1x.png"
              alt="Transakt"
              className="h-8 w-auto"
              srcSet="/logo-1x.png 1x, /logo-2x.png 2x"
            />
            <span className="text-xl font-semibold bg-gradient-to-r from-[#17DDAB] to-[#009FE4] bg-clip-text text-transparent">
              Transakt
            </span>
          </button>
          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate('/login')}
              className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900"
            >
              Log In
            </button>
            <button
              onClick={() => navigate('/signup')}
              className="px-4 py-2 text-sm text-white bg-gradient-to-r from-[#17DDAB] to-[#009FE4] rounded-md hover:opacity-90"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
